/**
 * Shop All Side Menu
 */
(() => {
  const query = document.querySelector('.verticalmenu nav');
  if (!query) return;

  const tier1s = [];

  /**
   * Logo
   */
  document.querySelector('.verticalmenu nav').prepend(
    document.querySelector('.logo').cloneNode(true),
  );

  /**
   * Tier 1
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children > a').forEach((item) => {
    tier1s.push(item.outerHTML);
    item.removeAttribute('href');
    item.innerHTML = `
        <div class="background"></div>
        <p>${item.innerHTML}</p>
      `;

    // Handle Hover Functionality
    item.addEventListener('mouseenter', (e) => {
      document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children')
        .forEach((itemmenu) => {
          if (itemmenu === e.currentTarget.parentNode) return;
          itemmenu.classList.remove('active');
        });
      e.currentTarget.parentNode.classList.add('active');
    });
  });

  /**
   * Tier 2 Sidebar
   */
  document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children .cd-secondary-dropdown').forEach((sidemenu, index) => {
    sidemenu.querySelector('.go-back').remove(); // remove back button

    sidemenu.innerHTML = `
      <div class="nLeft">
        <div class="nTop">
          ${`${tier1s[index]} - Shop All`}
        </div>
        <div class="nBottom">
          ${sidemenu.innerHTML}
        </div>
      </div>
    `;

    // Search box
    sidemenu.querySelector('.sideimage')?.remove();

    // Close button
    let close = document.createElement('div');
    close.innerHTML = '<a class="close-button">&times;</a>';
    close = close.firstElementChild;
    close.setAttribute('href', '#');
    close.addEventListener('click', () => {
      sidemenu.parentNode.classList.remove('active');
    });
    sidemenu.querySelector('.nLeft').prepend(close);
  });

  // Close button
  let close = document.createElement('div');
  close.innerHTML = '<a class="close-button">&times;</a>';
  close = close.firstElementChild;
  close.setAttribute('href', '#');
  close.addEventListener('click', () => {
    document.querySelector('body').click();

    document.querySelectorAll('.verticalmenu nav .cd-dropdown-content > li.has-children').forEach((itemmenu) => {
      itemmenu.classList.remove('active');
    });
  });
  document.querySelector('.cd-dropdown').prepend(close);
})();
